var LastViewedDevicesComponentController = (function () {
    function LastViewedDevicesComponentController(lastViewedService) {
        this.lastViewedService = lastViewedService;
        this.viewedDevices = [];
    }
    LastViewedDevicesComponentController.prototype.$onInit = function () {
        this.viewedDevices = this.lastViewedService.getLastViewed();
    };
    LastViewedDevicesComponentController.prototype.empty = function () {
        return this.viewedDevices.length === 0;
    };
    LastViewedDevicesComponentController.prototype.combine = function (devices) {
        var combined = '';
        for (var _i = 0, devices_1 = devices; _i < devices_1.length; _i++) {
            var device = devices_1[_i];
            combined += device.manufacturer + " " + device.name + ", ";
        }
        combined = combined.trim();
        return combined.slice(0, combined.length - 1);
    };
    LastViewedDevicesComponentController.$inject = ['lastViewedService'];
    return LastViewedDevicesComponentController;
}());
export var LastViewedDevicesComponent = {
    bindings: {
        onDevicesSelected: '&?',
    },
    controller: LastViewedDevicesComponentController,
    templateUrl: 'compatibilityguide/ng-templates/feature/search/lastvieweddevices',
};
